// extracted by mini-css-extract-plugin
var _1 = "tjs-full_screen_button__btn tjs-_buttons__btn tjs-_buttons__btn--map";
var _2 = "tjs-full_screen_button__enter";
var _3 = "tjs-full_screen_button__exit";
var _4 = "tjs-full_screen_button__full-screen";
var _5 = "tjs-full_screen_button__full-screen";
var _6 = "tjs-full_screen_button__fullScreenWrapper";
var _7 = "tjs-full_screen_button__isActive";
var _8 = "tjs-full_screen_button__minified";
var _9 = "tjs-full_screen_button__minifiedFullscreenBtnWrapper";
var _a = "tjs-full_screen_button__toggleWorkbench";
var _b = "tjs-full_screen_button__trainerBarVisible";
export { _1 as "btn", _2 as "enter", _3 as "exit", _4 as "full-screen", _5 as "fullScreen", _6 as "fullScreenWrapper", _7 as "isActive", _8 as "minified", _9 as "minifiedFullscreenBtnWrapper", _a as "toggleWorkbench", _b as "trainerBarVisible" }
export default { "btn": _1, "enter": _2, "exit": _3, "full-screen": _4, "fullScreen": _5, "fullScreenWrapper": _6, "isActive": _7, "minified": _8, "minifiedFullscreenBtnWrapper": _9, "toggleWorkbench": _a, "trainerBarVisible": _b }
